export const SET_USER_INFO = 'SetUserInfo';
export const SET_USER_TOKEN = 'SetUserToken';
export const LOGOUT_USER = 'LogoutUser';
export const SET_PAGE_TITLE = 'SetPageTitle';
export const SET_MENU_OPEN = 'SetMenuOpen';
export const SET_MENU_EXPANDED = 'SetMenuExpanded';
export const SET_LAST_MENU_ITEM_OPEN_ID = 'SetLastMenuItemOpenId';
export const SET_APP_NAME = 'SetAppName';
export const SET_USER_READY = 'SetUserReady';
export const CLEAR_LOCAL_STORAGE = 'ClearLocalStorage';
export const SET_MENU_RESULTS = 'SetMenuResults';
export const SET_PROFILE_MENU_RESULTS = 'SetProfileMenuResults';
export const SET_COMPANIES_RESULTS = 'SetCompanies';
export const COMPANIES_RESULTS_KEY = 'companiesResults';
export const SET_FAVORITES = 'SetFavorites';
export const SET_MENU_RESULTS_STORAGE = 'SetMenuResultsStorage';
export const SET_MAIN_ITEM_CLICKED = 'SetMainItemClicked';
export const SET_LAST_ITEM_CLICKED = 'SetLastItemClicked';
export const SET_NOTIFICATION_MODAL_CONTENT = 'SetNotificationModalContent';
export const SET_NOTIFICATION_MODAL_VISIBLE = 'SetNotificationModalVisible';
export const SET_ACTIVE_NOTIFICATIONS = 'SetActiveNotifications';
export const SET_DISMISSED_NOTIFICATIONS = 'SetDismissedNotifications';
export const SET_UNSHOWN_NOTIFICATIONS = 'SetUnShownNotificationItems';
export const REMOVE_SHOWN_NOTIFICATIONS = 'RemoveShownNotifications';
export const REMOVE_FROM_ACTIVE_NOTIFICATIONS = 'RemoveFromActiveNotifications';
export const ADD_UNSHOWN_ALERT = 'AddUnshownAlert';
export const ADD_TO_ACTIVE_NOTIFICATIONS = 'AddToActiveNotifications';
export const ADD_TO_DISMISSED_NOTIFICATIONS = 'AddToDismissedNotifications';
export const SET_PAGE_VERSION_CONFIGKEY_ID = 'SetPageVersionConfigKeyId';
export const SET_REQUEST_VERIFICATION_TOKEN = 'SetRequestVerificationToken';
export const SET_IFRAME_SOURCE = 'SetIframeSource';
export const SET_CURRENT_COMPANY_ID = 'SetCurrentCompanyId';
export const SET_CURRENT_ROUTE_MENU_ID = 'SetCurrentRouteMenuId';
export const SET_LAST_MAIN_ITEM_CLICKED = 'SetLastMainItemClicked';
export const SET_APP_CONFIGS = 'SetAppConfigs';
export const SET_ZONE_WARNING = 'SetZoneWarning';
export const SET_AUTOLOGOFF_STATUS = 'SetAutoLogoffStatus';
export const CLEAR_NOTIFICATIONS = 'ClearNotifications';
